<template>
  <div class="position-relative">
    <page-header
      :page="page"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    >
      <drop-down
        :items="actionItems"
        class="actions-dropdown pt-2"
        normal-size
        :always-show-dropdown="true"
      />
    </page-header>
    <div v-if="showCoordinateAppointment" class="mb-3">
      <coordinate-apointment
        @cancel="onCancelCoordinateAppointment"
        @save="onCoordinateAppointmentSaved"
        class="p-3"
        :request-referral="true"
      />
    </div>
    <div v-if="showCoordinateActivity" class="mb-3">
      <coordinate-activity
        @close="onCancelCoordinateActivity"
        @save="onFilterChange"
        class="p-3"
        :activities="filterOptions.activities"
        :defined-time="definedTime"
      />
    </div>

    <div class="d-flex justify-content-between mb-3 flex-wrap">
      <div class="mb-2">
        <button
          class="btn-calendar-type font-weight-bold mr-2"
          @click="changeView(1)"
          :class="{ 'tap-active': isTypeActive(1) }"
        >
          Hoy
        </button>
        <button
          class="btn-calendar-type font-weight-bold mr-2"
          @click="changeView(2)"
          :class="{ 'tap-active': isTypeActive(2) }"
        >
          Día
        </button>
        <button
          class="btn-calendar-type font-weight-bold mr-2"
          @click="changeView(3)"
          :class="{ 'tap-active': isTypeActive(3) }"
          v-if="!isMobile"
        >
          Semana
        </button>
        <button
          class="btn-calendar-type font-weight-bold"
          @click="changeView(4)"
          :class="{ 'tap-active': isTypeActive(4) }"
          v-if="!isMobile"
        >
          Mes
        </button>
      </div>
      <div class="d-flex align-items-center flex-wrap">
        <custom-radio
          v-model="selectedFilters"
          name="rbFilterTypeOptions"
          :options="filterTypeOptions"
          @input="onChangeFilterType"
          is-inline
        />

        <calendar-filter
          :academicyears="filterOptions.years"
          :statuses="filterOptions.status"
          :providers="filterOptions.providers"
          :participants="filterOptions.participants"
          :activities="filterOptions.activities"
          :selected-filters="selectedFilters"
          v-model="filterModel"
          @filter="onFilterChange"
        />
      </div>
    </div>
    <calendar-header
      :is-mobile="isMobile"
      :view-mode="currentView"
      :current-date="currentDate"
      :days="days"
      :caats="caats"
      :selected-caats="filterModel.caats"
      @add-day="addDay"
      @add-month="addMonth"
      @change-caat="handlerChangeCaat"
      @goToDay="goToDay"
      :defined-time="definedTime"
    />
    <div
      class="mb-3 calendar-container"
      :class="{
        'calendar-month': currentView === 4,
        'calendar-week': currentView === 3,
        'calendar-day': currentView === 1 || currentView === 2,
      }"
    >
      <div v-for="(day, key) in days" :key="key" v-if="!showNotInfo">
        <calendar-day
          v-if="currentView === 1 || currentView === 2"
          :is-mobile="isMobile"
          :key="key"
          :day="day"
          :current-date="currentDate"
          :events="listOfEvents"
          :show-day="currentView == calendarView.MONTH"
          @click="getDetail"
        />
        <calendar-week
          v-if="currentView === 3"
          :is-mobile="isMobile"
          :key="key"
          :day="day"
          :current-date="currentDate"
          :events="listOfEvents"
          :show-day="currentView == calendarView.MONTH"
          @click="getDetail"
        />
        <calendar-month
          v-if="currentView === 4"
          :key="key"
          :day="day"
          :current-date="currentDate"
          :events="listOfEvents"
          :show-day="currentView == calendarView.MONTH"
          @click="getDetail"
          @itemSelected="itemSelected"
        />
      </div>
      <div
        v-if="showNotInfo"
        class="not-info my-4 d-flex justify-content-center pt-5"
      >
        <custom-result-not-found
          class="mt-5 row pt-3"
          text="No hay Información Disponible."
        />
      </div>
      <calendar-sidebar
        v-model="showAppointment"
        :appointment="appointment"
        @edit-event="onFilterChange"
        @close="onCloseSidebar"
        :defined-time="definedTime"
      />
      <calendar-activity-sidebar
        v-model="showActivity"
        :activity="activity"
        @edit-event="onFilterChange"
        @close="() => (showActivity = false)"
        @cancel-activity="cancelActivity"
        :defined-time="definedTime"
      />
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import DropDown from 'dropdown';
import CoordinateApointment from '../referralAndEquipment/components/CoordinateApointment.vue';
import CalendarFilter from './components/CalendarFilter.vue';
import CalendarDay from './components/CalendarDay.vue';
import CalendarWeek from './components/CalendarWeek.vue';
import CalendarMonth from './components/CalendarMonth.vue';
import appointmentCalendarService from '@/services/api/appointmentcalendar.api';
import CoordinateActivity from './components/CoordinateActivity.vue';
import CalendarHeader from './components/CalendarHeader.vue';
import CustomResultNotFound from 'custom-result-not-found';
import referralAndEquipmentsService from '@/services/api/referralsandequipments.api';
import CalendarSidebar from './components/CalendarSidebar.vue';
import CalendarActivitySidebar from './components/CalendarActivitySidebar.vue';
import mixAlert from '@/mixins/alert.mixin';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import CustomRadio from '@/components/common/CustomRadio';

const CALEDAR_VIEWS = {
  TODAY: 1,
  DAY: 2,
  WEEK: 3,
  MONTH: 4,
};

const TEMPLATE_TAB_INDEX = {
  COORDINATEAPPOINMENT: 1,
  COORDINATEACTIVITY: 2,
};
const FilterTypes = {
  ShowAll: 1,
  Evaluations: 2,
  Activities: 3,
};

export default {
  name: 'Main',
  components: {
    PageHeader,
    DropDown,
    CoordinateApointment,
    CalendarFilter,
    CoordinateActivity,
    CalendarDay,
    CalendarHeader,
    CustomResultNotFound,
    CalendarSidebar,
    CalendarMonth,
    CalendarWeek,
    CustomRadio,
    CalendarActivitySidebar,
  },
  mixins: [mixAlert],
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    filterTypeOptions() {
      return [
        {
          label: 'Ver Todo',
          value: '1',
          className: 'bold-label',
        },
        {
          label: 'Evaluaciones',
          value: '2',
          className: 'bold-label',
        },
        {
          label: 'Actividades',
          value: '3',
          className: 'bold-label',
        },
      ];
    },
    showCoordinateActivity() {
      return (
        this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.COORDINATEACTIVITY
      );
    },
    showCoordinateAppointment() {
      return (
        this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.COORDINATEAPPOINMENT
      );
    },
    isTypeActive() {
      return (id) => id == this.currentView;
    },
    actionItems() {
      return [
        {
          name: 'Coordinar Cita',
          icon: 'fas fa-calendar-alt text-green',
          click: () => {
            this.selectedTemplateTabIndex =
              TEMPLATE_TAB_INDEX.COORDINATEAPPOINMENT;
          },
        },
        {
          name: 'Coordinar Actividad',
          icon: 'fas fa-calendar-alt text-green',
          click: () => {
            this.selectedTemplateTabIndex =
              TEMPLATE_TAB_INDEX.COORDINATEACTIVITY;
          },
        },
      ];
    },
    days() {
      switch (this.currentView) {
        case CALEDAR_VIEWS.TODAY:
          this.listOfDays = new Array(new Date());
          break;
        case CALEDAR_VIEWS.DAY:
          this.listOfDays = new Array(new Date(this.currentDate));
          break;
        case CALEDAR_VIEWS.WEEK:
          this.listOfDays = this.getDaysInWeek(this.currentDate);
          break;
        case CALEDAR_VIEWS.MONTH:
          this.listOfDays = this.getDaysInMonth();
          break;

        default:
          this.listOfDays = this.getDaysInMonth();
          break;
      }

      return this.listOfDays;
    },
    calendarView() {
      return CALEDAR_VIEWS;
    },
    showNotInfo() {
      return (
        (this.currentView == this.calendarView.TODAY ||
          this.currentView == this.calendarView.DAY) &&
        this.listOfEvents.filter((event) => {
          return (
            new Date(event.from).getDate() === this.currentDate.getDate() &&
            new Date(event.from).getMonth() === this.currentDate.getMonth() &&
            new Date(event.from).getFullYear() ===
              this.currentDate.getFullYear()
          );
        }).length === 0
      );
    },
    listOfEvents() {
      return this.events;
    },
  },
  data: () => ({
    selectedTemplateTabIndex: null,
    page: {
      icon: 'fas fa-list',
      title: 'Calendario de Citas',
      routes: ['Asistencia Tecnológica', 'Calendario de Citas'],
    },
    selectedFilters: FilterTypes.ShowAll.toString(),
    filterOptions: {
      years: [],
      status: [],
      activities: [],
      providers: [],
      participants: [],
    },
    filterModel: {
      academicYear: null,
      student: null,
      status: null,
      activity: null,
      provider: null,
      participant: null,
      caats: [],
    },
    currentView: CALEDAR_VIEWS.TODAY,
    currentDate: new Date(),
    listOfDays: [],
    events: [],
    caats: [],
    showAppointment: false,
    showActivity: false,
    appointment: {},
    activity: {},
    definedTime: {},
  }),
  async created() {
    await Promise.all([
      this.getAcademicYears(),
      this.initFilter(),
      this.getCalendarDefinedTime(),
    ]);
    this.onFilterChange();
  },
  methods: {
    async initFilter() {
      const { data } = await appointmentCalendarService.getFilterOptions();
      this.filterOptions.status = data.status;
      this.filterOptions.providers = data.providers;
      this.filterOptions.activities = data.activities;
      this.filterOptions.participants = data.participants.map((item) => ({
        id: item.userId,
        name: item.fullName,
      }));

      this.caats = data.caats;
      this.filterModel.caats = data.caats
        .filter((x) => x.selected)
        .map((x) => x.id);
    },
    async getCalendarDefinedTime() {
      const {
        data,
      } = await appointmentCalendarService.getDefinedCalendarTime();
      this.definedTime = data;
    },
    async getAcademicYears() {
      const { data } = await referralAndEquipmentsService.getAcademicyears();
      this.filterOptions.years = data.map((item) => ({
        id: item.id,
        name: item.description,
      }));
    },
    async getDetail(item) {
      if (item.isAppointment) {
        await this.getAppointmentDetails(item);
        return;
      }

      await this.getActivityDetails(item);
    },
    async getAppointmentDetails({ id }) {
      try {
        const { data } = await appointmentCalendarService.getAppointment(id);
        this.appointment = data;
        this.showAppointment = true;
      } catch (error) {
        this.ShowToast(
          'Error',
          'Ha ocurrido un obteniendo la información de la cita',
          'error'
        );
      }
    },
    async getActivityDetails({ id }) {
      try {
        const { data } = await appointmentCalendarService.getActivity(id);
        this.activity = data;
        this.showActivity = true;
      } catch (error) {
        this.ShowToast(
          'Error',
          'Ha ocurrido un obteniendo la información de la cita',
          'error'
        );
      }
    },
    async goToDay(item) {
      this.currentDate = item;
      this.changeView(this.currentView);
    },
    async itemSelected(item) {
      if (this.caats.some((x) => x.id === item.caatId)) {
        this.filterModel.caats = [item.caatId];
      }

      this.currentDate = new Date(item.from);
      this.changeView(CALEDAR_VIEWS.DAY);
    },
    onShowCoordinateAppointment() {
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.COORDINATEAPPOINMENT;
    },
    onShowCoordinateActivity() {
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.COORDINATEACTIVITY;
    },
    onCancelCoordinateAppointment() {
      this.selectedTemplateTabIndex = null;
    },
    onCoordinateAppointmentSaved() {
      this.selectedTemplateTabIndex = null;
      this.onFilterChange();
    },
    changeView(view) {
      this.currentView = view;
      this.handlerDatesToFilter();
      this.onFilterChange();
    },
    getDaysInMonth() {
      const date = this.currentDate;
      const year = date.getFullYear();
      const month = date.getMonth();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const days = Array.from({ length: daysInMonth }, (_, i) => {
        return new Date(year, month, i + 1);
      });

      // Obtener el día de la semana del primer día del mes
      const firstDayOfWeek = new Date(year, month, 0).getDay() - 1;
      // Calcular cuántos días del mes anterior deben agregarse
      const daysToAddFromPreviousMonth =
        firstDayOfWeek === 0 ? 6 : firstDayOfWeek;

      // Obtener el último día del mes anterior
      const lastDayOfPreviousMonth = new Date(year, month, 0).getDate();

      for (let i = 0; i < daysToAddFromPreviousMonth; i++) {
        days.unshift(new Date(year, month - 1, lastDayOfPreviousMonth - i));
      }

      // Calcular cuántos días del mes siguiente deben agregarse
      const lastDayOfWeek = new Date(year, month, daysInMonth).getDay();
      let daysToAddFromNextMonth = lastDayOfWeek === 0 ? 6 : 7 - lastDayOfWeek;

      if (days.length + daysToAddFromNextMonth < 42) {
        let daysToAdd = 42 - (days.length + daysToAddFromNextMonth);
        daysToAddFromNextMonth += daysToAdd;
      }

      // Agregar días del mes siguiente
      for (let i = 1; i <= daysToAddFromNextMonth; i++) {
        days.push(new Date(year, month + 1, i));
      }

      return days;
    },
    getDaysInWeek(date) {
      const days = [];
      const dayOfWeek = date.getDay() - 1;
      const startOfWeek = new Date(date);
      startOfWeek.setDate(date.getDate() - dayOfWeek);

      for (let i = 0; i < 7; i++) {
        const currentDay = new Date(startOfWeek);
        currentDay.setDate(startOfWeek.getDate() + i);
        days.push(new Date(currentDay));
      }

      return days;
    },
    addMonth(months) {
      this.currentDate = new Date(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth() + months,
        1
      );
      this.onFilterChange();
    },
    addDay(days) {
      this.currentDate = new Date(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth(),
        this.currentDate.getDate() + days
      );
      this.listOfDays = [this.currentDate];
      this.onFilterChange();
    },
    async onFilterChange() {
      const {
        academicYear,
        status,
        activity,
        provider,
        participant,
        student,
        caats,
      } = this.filterModel;

      if (caats.length === 0) {
        this.events = [];
        return;
      }

      const { data } = await appointmentCalendarService.getAppointments({
        fiscalYearId: (academicYear || {}).id,
        statusId: (status || {}).id,
        activityId: (activity || {}).id,
        providerId: (provider || {}).id,
        participantId: (participant || {}).id,
        keyword: student,
        caats: caats || [],
        fromDate: this.handlerDatesToFilter().fromDate,
        toDate: this.handlerDatesToFilter().toDate,
        onlyActivities:
          this.selectedFilters == FilterTypes.Activities
            ? true
            : this.selectedFilters == FilterTypes.Evaluations
            ? false
            : null,
      });
      this.events = data;
    },
    handlerDatesToFilter() {
      let fromDate;
      let toDate;

      switch (this.currentView) {
        case CALEDAR_VIEWS.TODAY:
          this.currentDate = new Date();
          fromDate = this.currentDate;
          toDate = this.currentDate;
          break;
        case CALEDAR_VIEWS.DAY:
          fromDate = this.currentDate;
          toDate = this.currentDate;
          break;
        case CALEDAR_VIEWS.WEEK:
          fromDate = this.getDaysInWeek(this.currentDate)[0];
          toDate = this.getDaysInWeek(this.currentDate)[6];
          break;
        case CALEDAR_VIEWS.MONTH:
          fromDate = new Date(
            this.currentDate.getFullYear(),
            this.currentDate.getMonth(),
            1
          );
          toDate = new Date(
            this.currentDate.getFullYear(),
            this.currentDate.getMonth() + 1,
            0
          );
          break;

        default:
          this.listOfDays = this.getDaysInMonth();
          break;
      }

      return { fromDate, toDate };
    },
    onCancelCoordinateActivity() {
      this.selectedTemplateTabIndex = null;
    },
    handlerChangeCaat(caat) {
      const exist = this.filterModel.caats.includes(caat.id);
      if (exist) {
        this.filterModel.caats = this.filterModel.caats.filter(
          (id) => id !== caat.id
        );
      } else {
        this.filterModel.caats.push(caat.id);
      }

      this.onFilterChange();
    },
    onChangeFilterType(value) {
      if (value == FilterTypes.Evaluations) {
        this.filterModel.activity = null;
      }
      this.onFilterChange();
    },
    onCloseSidebar() {
      this.onFilterChange();
    },
    async cancelActivity(item) {
      try {
        await appointmentCalendarService.cancelActivity(item.id);
        this.showActivity = false;
        this.ShowToast(
          'Éxito',
          'Información ha sido guardada exitosamente.',
          'success'
        );
        this.onFilterChange();
      } catch (error) {
        this.ShowToast(
          'Error',
          'Ha ocurrido un obteniendo la información de la cita',
          'error'
        );
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/shared/scss/config/_colors.scss';

.week-day {
  background: #d9e5df;
  font-weight: 700;
  font-size: 16px;
}

.calendar-month {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 15px;
  width: 100%;
  height: 100%;
}

.calendar-week {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 15px;
  width: 100%;
  height: 100%;
  min-height: 70vh;
}

.calendar-day {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 15px;
  width: 100%;
  height: 100%;
  min-height: 70vh;
}

.not-info {
  display: flex;
  flex-direction: row;
  width: 100% !important;
  height: 100%;
  background-color: #f4f6f3;
  border-radius: 4px;
  padding: 16px;
  justify-content: flex-end;
  min-height: 150px;
}

.btn-calendar-type {
  background-color: #f4f6f3;
  border-radius: 4px;
  width: 99px;
  height: 40px;
  border: none;
}
.tap-active {
  background-color: map-get($colors, 'orange');
  color: #fff;
}
.bold-label {
  font-weight: bold;
  color: black;
}
.vdp-datepicker__calendar .disabled {
  color: #ddd !important;
  cursor: default;
}
</style>
